module.exports = __webpack_public_path__ + "danceparty-sloth-2019wpd14550cde507a22cf9afffe9720dc5b5.png";